"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./FullBackgroundHero.scss");
var _FullBackgroundHeroMethods = require("./FullBackgroundHeroMethods");
var _useWindowSize = _interopRequireDefault(require("../../utils/hooks/useWindowSize"));
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
var _reactAwesomeReveal = require("react-awesome-reveal");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FullBackgroundHero = _ref => {
  let {
    contentfulId,
    content,
    theme,
    motion,
    paddingClass,
    lazyLoad
  } = _ref;
  const {
    variant = "variant-1",
    backgroundImage,
    bottomBackgroundImage,
    leftContent,
    rightContent,
    rightImage,
    shapeType = "square",
    shapeBorderColor = "#F1F1F6",
    rightContentType
  } = content;
  const {
    size
  } = (0, _useWindowSize.default)();
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    backgroundColor,
    color
  } = (0, _useStyles.default)(themes);
  let twoByTwoModifier = "";
  const productPage = variant === "variant-3" ? true : false;
  if (rightContentType) {
    twoByTwoModifier = rightContentType === "Contentful2X2" ? "luna-full-background-hero--2x2" : "";
  }
  const generateLottieRatio = () => {
    let lottieHeight = 1,
      lottieWidth = 1;
    switch (variant) {
      case "variant-1":
        lottieHeight = 9;
        lottieWidth = 16;
        break;
      case "variant-2":
        lottieHeight = 73;
        lottieWidth = 240;
        break;
      case "variant-2-inset":
        lottieHeight = 9;
        lottieWidth = 16;
        break;
      case "variant-3":
        lottieHeight = 7;
        lottieWidth = 20;
        break;
      default:
        // use the original 1:1 ratio above
        break;
    }
    return {
      height: lottieHeight,
      width: lottieWidth
    };
  };
  const hasLottieBackground = backgroundImage?.type === 'lottieAnimation' || bottomBackgroundImage?.type === 'lottieAnimation';
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `
        luna-full-background-hero 
        luna-full-background-hero-${variant} ${paddingClass} 
        ${twoByTwoModifier}
        ${backgroundImage?.lazyLoad === false ? ' luna-full-background-hero--no-transition' : ''}
        ${productPage ? "luna-full-background-hero--product" : ''}
      `,
    style: {
      background: backgroundColor,
      color: color
    },
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: `
          luna-full-background-hero__image-wrapper 
          luna-full-background-hero__image-wrapper-${variant} 
          ${hasLottieBackground === true ? "luna-full-background-hero__image-wrapper-background--lottie" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-full-background-hero__image-wrapper-background-${variant}`,
    style: {
      background: backgroundColor
    },
    "data-sb-field-path": "backgroundImage"
  }, (0, _FullBackgroundHeroMethods.renderFullBgHeroImage)(backgroundImage, size, variant, "luna-full-background-hero__lottie-image", generateLottieRatio())), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-full-background-hero__image-wrapper-content-${variant}`,
    "data-sb-field-path": "bottomBackgroundImage"
  }, bottomBackgroundImage && (0, _FullBackgroundHeroMethods.renderFullBgHeroImage)(bottomBackgroundImage, size, variant, "luna-full-background-hero__image", generateLottieRatio()))), /*#__PURE__*/_react.default.createElement(_reactAwesomeReveal.Fade, {
    direction: motion ? "up" : "",
    delay: motion ? 100 : 0,
    triggerOnce: true,
    className: `
          luna-full-background-hero__content-wrapper 
          luna-full-background-hero__content-wrapper-${variant}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `
            luna-full-background-hero__content-wrapper-grid 
            luna-full-background-hero__content-wrapper-grid-${variant}`,
    style: variant === "variant-2" ? {
      gridTemplateRows: "5px 1fr"
    } : {
      gridTemplateRows: "1fr"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `
                luna-full-background-hero__content-wrapper-left 
                luna-full-background-hero__content-wrapper-left-${variant} 
                ${backgroundColor === "#FFFFFF" ? `luna-full-background-hero__white-bg` : ``}
                ${!rightContent ? `luna-full-background-hero__content-wrapper-left-${variant}--full` : ""}
                ${rightImage ? `luna-full-background-hero__content-wrapper-left-${variant}--image` : ""}
                ${!rightContent && !rightImage ? `luna-full-background-hero__content-wrapper-left--no-bottom-margin` : ``}
              `,
    "data-sb-field-path": "leftContent"
  }, leftContent), /*#__PURE__*/_react.default.createElement("div", {
    className: `
                luna-full-background-hero__content-wrapper-right 
                luna-full-background-hero__content-wrapper-right-${variant} 
                ${!rightContent && !rightImage ? `luna-full-background-hero__content-wrapper-right--no-content` : ``}
                ${rightImage ? `luna-full-background-hero__content-wrapper-right--image` : ``}`,
    "data-sb-field-path": "rightContent"
  }, (variant === "variant-1" || variant === "variant-2-inset") && rightContent, variant === "variant-2" && rightImage && (0, _FullBackgroundHeroMethods.renderShape)(shapeBorderColor, rightImage, shapeType, size, variant), variant === "variant-3" && rightImage && (0, _FullBackgroundHeroMethods.renderFullBgHeroImage)(rightImage, null, variant)))));
};
var _default = FullBackgroundHero;
exports.default = _default;